import React from 'react';
import PropTypes from 'prop-types';

import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import AdminOptionsButton from 'shared-components/AdminOptionsButton/AdminOptionsButton';
import styles from './TableButtons.module.scss';

const TableButtons = ({
  isSaleCart,
  disabled,
  downloadCartsItems,
  downloadCartsData,
  openModal,
}) => (
  <div className={styles.container}>
    {isSaleCart ? (
      <AdminOptionsButton
        buttonType={BUTTON_TYPES.PRIMARY_INVERSE}
        options={downloadCartsItems}
        disabled={disabled}
        buttonClass={styles.iconButton}
        menuStyle={{ width: '140px' }}
      >
        <i className="far fa-arrow-to-bottom" />
      </AdminOptionsButton>
    ) : (
      <Button
        buttonType={BUTTON_TYPES.PRIMARY_INVERSE}
        disabled={disabled}
        className={styles.iconButton}
        onClick={downloadCartsData}
      >
        <i className="far fa-arrow-to-bottom" />
      </Button>
    )}
    <Button
      buttonType={BUTTON_TYPES.PRIMARY}
      style={{ width: '180px' }}
      onClick={openModal}
    >
      Upload CSV
    </Button>
  </div>
);

TableButtons.propTypes = {
  isSaleCart: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  downloadCartsItems: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  downloadCartsData: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
};

export default TableButtons;
